// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main[data-v-c875c204] {\n  display: flex;\n  flex-flow: row;\n}\n.main .nav-wrap[data-v-c875c204] {\n    position: relative;\n    margin: 14px 20px 0 0;\n    width: 155px;\n}\n", ""]);
// Exports
module.exports = exports;
